import { dataimportJwt } from "../dataimport/dwdataimport";
import { collectAndPrintToConsoleLog, collectLog, concatLogsAndVars, createEmptyLogsAndVars, recordVariable, ReportingError, } from "../diagnostics/clientErrors";
import { readFileJwt, removeFile } from "../dwclient/dwstorage";
import { loadJwt } from "../dwclient/localstorage/jwtStorage";
import { addLeadingSlash, splitPath, splitPathWithoutFirstElement } from "../paths";
import { ensureAuxStructures2, recreateAuxStructures2 } from "./graphauxcreator2";
import { unProcessAndSaveProcessedGraphJwt } from "./graphloader2";
import { findNodeId2, firstLink2, newFolder2, mkdirs2, newFile2, RELATION_FILE_FOLDER2, findChildrenOfNodeById2, TYPE_FILE2, deleteSingle2, TYPE_ROOT2, TYPE_FOLDER2, } from "./graphmodifier2";
import { myRemoveFileJwt } from "../dwclient/dwstorageutils";
// TODO átírni
export async function mergeStorageFilesList2(processedGraph, filesListEntries) {
    ensureAuxStructures2(processedGraph);
    const parentId = findNodeId2(processedGraph, "/dataOwnerFiles");
    if (parentId === undefined) {
        throw new Error("/dataOwnerFiles does not exist");
    }
    const oldUploadedId = newFolder2(processedGraph, "Uploaded");
    const uploadedFolderId = firstLink2(processedGraph, parentId, oldUploadedId);
    for (const file of filesListEntries) {
        const pathParts = splitPath(file.path);
        if (pathParts?.folder === undefined) {
            continue;
        }
        const lastFolderId = mkdirs2(processedGraph, uploadedFolderId, pathParts.folder);
        const oldFileId = newFile2(processedGraph, pathParts.name, file.size, file.metadata["Content-Type"] ?? "", file.path, file.creationTime);
        firstLink2(processedGraph, lastFolderId, oldFileId);
    }
    recreateAuxStructures2(processedGraph);
}
// TODO átírni
export async function ensureStorageFilesList2(provider, processedGraph, filesListEntries) {
    const logsAndVars = createEmptyLogsAndVars("ensureStorageFilesList2");
    recreateAuxStructures2(processedGraph);
    const rootFolder = findFileSystemRoot2(processedGraph);
    if (rootFolder === undefined) {
        collectAndPrintToConsoleLog(logsAndVars, "file system root is missing");
        throw new ReportingError("file system root is missing", logsAndVars);
    }
    let change = false;
    const filesListEntriesWithOnlyLatestDumps = filterOutEarlierDumps(filesListEntries);
    for (const file of filesListEntriesWithOnlyLatestDumps) {
        let fullPath = file.path;
        if (!fullPath.startsWith("/User Files") && !fullPath.startsWith("/dataOwnerFiles")) {
            fullPath = "/User Files/Uploaded" + fullPath;
        }
        recordVariable(logsAndVars, "StorJ file item", file.path + " full path: " + fullPath);
        const fileNodeId = findFileSystemNodeId2(processedGraph, fullPath);
        if (fileNodeId === undefined) {
            collectAndPrintToConsoleLog(logsAndVars, "File " + file.path + " (full path: " + fullPath + ") is missing: creating");
            if (file?.path && (file.path.startsWith("/User Files/Imported") || file.path.startsWith("User Files/Imported"))) {
                await reimport(logsAndVars, provider, processedGraph, file);
            }
            reconnectRegularFile(logsAndVars, processedGraph, rootFolder, file, fullPath);
            change = true;
        }
        else {
            collectAndPrintToConsoleLog(logsAndVars, "File " + fullPath + " is FOUND");
        }
    }
    recordVariable(logsAndVars, "ensureStorageFilesList result (graph is changed)", change);
    return change;
}
async function reimport(logsAndVars, provider, processedGraph, file) {
    if (file.size > 0) {
        if (file.path.includes("Amazon")) {
            const authToken = (await loadJwt()) ?? "";
            const downloadedFile = await readFileJwt(provider, authToken, file.path, file.size);
            await dataimportJwt(provider, authToken, "amazon", downloadedFile);
        }
    }
}
function filterOutEarlierDumps(filesListEntries) {
    // TODO supposed that there are only "amazon" dumps
    const retList = [];
    let maxAmazonDump = undefined;
    for (const fileEntry of filesListEntries) {
        if (fileEntry.path.startsWith("/User Files/Imported/Amazon") ||
            fileEntry.path.startsWith("User Files/Imported/Amazon")) {
            if (maxAmazonDump === undefined || fileEntry.creationTime > maxAmazonDump.creationTime) {
                maxAmazonDump = fileEntry;
            }
        }
        else {
            retList.push(fileEntry);
        }
    }
    if (maxAmazonDump !== undefined) {
        retList.push(maxAmazonDump);
    }
    //console.log("filterOutEarlier", retList);
    return retList;
}
function reconnectRegularFile(logsAndVars, processedGraph, rootFolder, file, fullPath) {
    const pathParts = splitPathWithoutFirstElement(fullPath);
    if (pathParts?.folder === undefined) {
        return;
    }
    const lastFolderId = mkdirs2(processedGraph, rootFolder.id, pathParts.folder);
    collectLog(logsAndVars, "mkdirs result", lastFolderId);
    const oldFileId = newFile2(processedGraph, pathParts.name, file.size, file.metadata["Content-Type"] ?? "", file.path, file.creationTime);
    collectLog(logsAndVars, "newFile result", oldFileId);
    //console.log("lastFolderId", lastFolderId, "oldFileId", oldFileId);
    firstLink2(processedGraph, lastFolderId, oldFileId);
    collectLog(logsAndVars, "firstLink result");
}
// OK
export function findFileSystemRoot2(processedGraph) {
    return processedGraph.nodes.find((node) => node._type === TYPE_ROOT2);
}
// OK
function findFileSystemNodeId2(processedGraph, fullPath) {
    if (!fullPath.startsWith("/dataOwnerFiles") && !fullPath.startsWith("/User Files")) {
        return undefined;
    }
    let pathwithoutDataOwnerFiles;
    if (fullPath.startsWith("/dataOwnerFiles")) {
        pathwithoutDataOwnerFiles = fullPath.substring("/dataOwnerFiles".length);
    }
    if (fullPath.startsWith("/User Files")) {
        pathwithoutDataOwnerFiles = fullPath.substring("/User Files".length);
    }
    const fileSystemRoot = findFileSystemRoot2(processedGraph);
    if (fileSystemRoot === undefined) {
        return undefined;
    }
    return findNodeId2(processedGraph, pathwithoutDataOwnerFiles, fileSystemRoot.id);
}
// OK
/// Removes the file content of the folder from StorJ AND removes their entries from Graph (JSON)
export async function deleteFilesFromFolder2(storageProps, processedGraph, folderPath) {
    let logsAndVars = createEmptyLogsAndVars("deleteFilesFromFolder");
    try {
        recordVariable(logsAndVars, "folderPath (param)", folderPath);
        const fileSystemRoot = findFileSystemRoot2(processedGraph);
        const folderNodeId = findNodeId2(processedGraph, folderPath, fileSystemRoot?.id);
        recordVariable(logsAndVars, "found folderNodeId", folderNodeId);
        //console.log("folder node id", folderNodeId);
        if (folderNodeId === undefined) {
            return;
        }
        await deleteFilesFromFolderNodeId2(storageProps, processedGraph, folderNodeId);
    }
    catch (error) {
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        throw new ReportingError(error, logsAndVars);
    }
}
// OK
export async function deleteFilesFromFolderNodeId2(storageProps, processedGraph, folderNodeId) {
    let logsAndVars = createEmptyLogsAndVars("deleteFilesFromFolderNodeId");
    try {
        recordVariable(logsAndVars, "folderNodeId (param)", folderNodeId);
        const childNodes = findChildrenOfNodeById2(processedGraph, folderNodeId, [RELATION_FILE_FOLDER2], undefined, false);
        recordVariable(logsAndVars, "content of folder", childNodes.map((node) => node.label + " " + node.id + " " + node.storagePath + " " + node._type));
        let deleted = false;
        for (const childNode of childNodes) {
            if (childNode._type === TYPE_FILE2) {
                deleted = true;
                collectLog(logsAndVars, "Starting to delete from graph: ", childNode.id);
                await deleteSingle2(processedGraph, childNode.id);
                collectLog(logsAndVars, "Starting to remove from StorJ: ", childNode.storagePath);
                if (childNode.storagePath) {
                    try {
                        await removeFile(storageProps, childNode.storagePath);
                    }
                    catch (error) {
                        collectLog(logsAndVars, "error occurred in removeFile. Continuing.", error.message);
                    }
                }
            }
        }
        //console.log("logsAndVars", logsAndVars);
        if (deleted) {
            collectLog(logsAndVars, "Starting to save processedGraph");
            const authToken = await loadJwt();
            if (authToken !== null) {
                //processedGraph.nodes = [];
                await unProcessAndSaveProcessedGraphJwt(authToken, processedGraph);
            }
        }
    }
    catch (error) {
        //console.log("ERROR logsAndVars", logsAndVars);
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        throw new ReportingError(error, logsAndVars);
    }
}
export async function deleteRecursiveJwt(processedGraph, folderPath) {
    let logsAndVars = createEmptyLogsAndVars("deleteRecursiveJwt");
    try {
        recordVariable(logsAndVars, "folderPath (param)", folderPath);
        const fileSystemRoot = findFileSystemRoot2(processedGraph);
        const folderNodeId = findNodeId2(processedGraph, folderPath, fileSystemRoot?.id);
        recordVariable(logsAndVars, "found folderNodeId", folderNodeId);
        //console.log("folder node id", folderNodeId);
        if (folderNodeId === undefined) {
            return;
        }
        await deleteNodeRecursiveJwt(processedGraph, folderNodeId);
    }
    catch (error) {
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        throw new ReportingError(error, logsAndVars);
    }
}
export async function deleteNodeRecursiveJwt(processedGraph, folderNodeId) {
    let logsAndVars = createEmptyLogsAndVars("deleteNodeRecursiveJwt");
    try {
        ensureAuxStructures2(processedGraph);
        const authToken = await loadJwt();
        recordVariable(logsAndVars, "authToken (param)", authToken);
        if (authToken == null) {
            return;
        }
        const deleted = await internalDeleteNodeRecursiveJwt(authToken, processedGraph, folderNodeId);
        if (deleted) {
            collectLog(logsAndVars, "Starting to save processedGraph");
            const authToken = await loadJwt();
            if (authToken !== null) {
                //processedGraph.nodes = [];
                await unProcessAndSaveProcessedGraphJwt(authToken, processedGraph);
            }
        }
    }
    catch (error) {
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        throw new ReportingError(error, logsAndVars);
    }
}
async function internalDeleteNodeRecursiveJwt(authToken, processedGraph, folderNodeId) {
    let logsAndVars = createEmptyLogsAndVars("deleteNodeRecursiveJwt");
    try {
        recordVariable(logsAndVars, "folderNodeId (param)", folderNodeId);
        const childNodes = findChildrenOfNodeById2(processedGraph, folderNodeId, [RELATION_FILE_FOLDER2], undefined, false);
        recordVariable(logsAndVars, "content of folder", childNodes.map((node) => node.label + " " + node.id + " " + node.storagePath + " " + node._type));
        for (const childNode of childNodes) {
            if (childNode._type === TYPE_FILE2) {
                collectLog(logsAndVars, "Starting to delete from graph: ", childNode.id);
                await deleteSingle2(processedGraph, childNode.id);
                collectLog(logsAndVars, "Starting to remove from StorJ: ", childNode.storagePath);
                if (childNode.storagePath) {
                    try {
                        await myRemoveFileJwt(authToken, childNode.storagePath);
                    }
                    catch (error) {
                        collectLog(logsAndVars, "error occurred in removeFile. Continuing.", error.message);
                    }
                }
            }
            else if (childNode._type === TYPE_FOLDER2) {
                await internalDeleteNodeRecursiveJwt(authToken, processedGraph, childNode.id);
            }
        }
        const folderNode = processedGraph.aux?.getNodeById(folderNodeId);
        let folderDeleted = false;
        if (folderNode !== undefined && !folderNode.readonly) {
            await deleteSingle2(processedGraph, folderNodeId);
            folderDeleted = true;
            collectLog(logsAndVars, "Deleted folder node: ", folderNodeId);
        }
        return folderDeleted;
    }
    catch (error) {
        //console.log("ERROR logsAndVars", logsAndVars);
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        throw new ReportingError(error, logsAndVars);
    }
}
/**
 * Normalize a path for comparison by:
 * - Ensuring leading slash
 * - Converting to lowercase
 * - Replacing multiple spaces/hyphens with single hyphen
 * - Trimming whitespace
 * This allows matching paths like "/Uploaded/Dwinity Upload/file.jpg" with "/Uploaded/dwinity-upload/file.jpg"
 */
function normalizePathForComparison(path) {
    let normalized = path.startsWith("/") ? path : "/" + path;
    // Split into folder parts to normalize each segment
    const parts = normalized.split("/");
    const normalizedParts = parts.map((part) => {
        // Convert to lowercase
        let p = part.toLowerCase();
        // Replace spaces with hyphens
        p = p.replace(/\s+/g, "-");
        // Collapse multiple hyphens into one
        p = p.replace(/-+/g, "-");
        // Remove leading/trailing hyphens from each part
        p = p.replace(/^-+|-+$/g, "");
        return p;
    });
    return normalizedParts.join("/");
}
export async function deleteNodesByStoragePaths(processedGraph, storagePaths) {
    if (!storagePaths || storagePaths.length === 0) {
        return { deletedNodes: 0, deletedFolders: 0 };
    }
    // Ensure aux structures are fresh before we start
    recreateAuxStructures2(processedGraph);
    const normalizedPaths = storagePaths.map(addLeadingSlash);
    // Build a set of normalized paths for fuzzy matching
    const normalizedPathSet = new Set();
    // Also keep original paths for exact matching (preferred)
    const exactPathSet = new Set();
    const knownPrefixes = ["/User Files", "/dataOwnerFiles"];
    for (const p of normalizedPaths) {
        // Add exact path
        exactPathSet.add(p);
        // Add normalized version
        normalizedPathSet.add(normalizePathForComparison(p));
        // Also add variations without known prefixes
        let basePath = p;
        let changed = true;
        while (changed) {
            changed = false;
            for (const prefix of knownPrefixes) {
                if (basePath.startsWith(prefix + "/")) {
                    basePath = basePath.substring(prefix.length);
                    exactPathSet.add(basePath);
                    normalizedPathSet.add(normalizePathForComparison(basePath));
                    changed = true;
                }
            }
        }
        // Add with known prefixes
        for (const prefix of knownPrefixes) {
            exactPathSet.add(prefix + basePath);
            normalizedPathSet.add(normalizePathForComparison(prefix + basePath));
        }
    }
    console.log("[Graph Cleanup] Looking for paths (exact):", Array.from(exactPathSet).slice(0, 5), "... total:", exactPathSet.size);
    console.log("[Graph Cleanup] Looking for paths (normalized):", Array.from(normalizedPathSet).slice(0, 5));
    let deletedNodes = 0;
    let deletedFolders = 0;
    // Collect node IDs to delete by iterating the nodes array directly
    const nodeIdsToDelete = [];
    const graphFilePaths = [];
    for (const node of processedGraph.nodes) {
        if (node._type === TYPE_FILE2 && node.storagePath) {
            const exactPath = addLeadingSlash(node.storagePath);
            const normalizedPath = normalizePathForComparison(exactPath);
            graphFilePaths.push(exactPath);
            // Try exact match first, then normalized match
            if (exactPathSet.has(exactPath)) {
                console.log("[Graph Cleanup] EXACT MATCH found:", exactPath, "nodeId:", node.id, "node:", node);
                nodeIdsToDelete.push(node.id);
            }
            else if (normalizedPathSet.has(normalizedPath)) {
                console.log("[Graph Cleanup] NORMALIZED MATCH found:", exactPath, "->", normalizedPath, "nodeId:", node.id, "node:", node);
                nodeIdsToDelete.push(node.id);
            }
        }
    }
    console.log("[Graph Cleanup] Graph has", graphFilePaths.length, "file nodes. Sample paths:", graphFilePaths.slice(0, 10));
    if (nodeIdsToDelete.length === 0 && storagePaths.length > 0) {
        // Debug: show why nothing matched
        const sampleGraphNormalized = graphFilePaths.slice(0, 5).map((p) => normalizePathForComparison(p));
        console.log("[Graph Cleanup] No matches found. Sample graph paths normalized:", sampleGraphNormalized);
        return { deletedNodes: 0, deletedFolders: 0 };
    }
    console.log("[Graph Cleanup] Deleting", nodeIdsToDelete.length, "nodes via deleteSingle2:", nodeIdsToDelete);
    // Delete nodes using deleteSingle2 (maintains aux structure consistency)
    for (const nodeId of nodeIdsToDelete) {
        try {
            // deleteSingle2 will call ensureAuxStructures2 internally and recreate after
            deleteSingle2(processedGraph, nodeId);
            deletedNodes++;
            console.log(`[Graph Cleanup] Successfully deleted node ${nodeId}`);
        }
        catch (error) {
            console.warn(`[Graph Cleanup] Failed to delete node ${nodeId}:`, error);
        }
    }
    // Clean up empty folders
    if (deletedNodes > 0) {
        const emptyFolders = findEmptyFolders(processedGraph);
        for (const folderId of emptyFolders) {
            try {
                const folderNode = processedGraph.aux?.getNodeById(folderId);
                if (folderNode && !folderNode.readonly) {
                    deleteSingle2(processedGraph, folderId);
                    deletedFolders++;
                }
            }
            catch (error) {
                console.warn(`[Graph Cleanup] Failed to delete empty folder ${folderId}:`, error);
            }
        }
    }
    // ALWAYS save if we found matches to delete (regardless of success count)
    if (nodeIdsToDelete.length > 0) {
        console.log("[Graph Cleanup] Saving graph to backend...");
        const authToken = await loadJwt();
        if (authToken !== null) {
            await unProcessAndSaveProcessedGraphJwt(authToken, processedGraph);
            console.log("[Graph Cleanup] Graph saved successfully");
        }
        else {
            console.warn("[Graph Cleanup] No auth token, cannot save graph!");
        }
    }
    console.log(`[Graph Cleanup] Complete: ${deletedNodes} nodes, ${deletedFolders} folders removed`);
    return { deletedNodes, deletedFolders };
}
function findEmptyFolders(processedGraph) {
    ensureAuxStructures2(processedGraph);
    const emptyFolders = [];
    for (const node of processedGraph.nodes) {
        if (node._type === TYPE_FOLDER2 && !node.readonly) {
            const children = processedGraph.aux?.getEdgesByFrom(node.id) || [];
            const nonMetaChildren = children.filter((edge) => edge._type === RELATION_FILE_FOLDER2);
            if (nonMetaChildren.length === 0) {
                emptyFolders.push(node.id);
            }
        }
    }
    return emptyFolders;
}
